(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDataDeleteController',TimeseriesDataDeleteController);

    TimeseriesDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'TimeseriesData'];

    function TimeseriesDataDeleteController($uibModalInstance, entity, TimeseriesData) {
        var vm = this;

        vm.timeseriesData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TimeseriesData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
